export const REMEMBER_PROJECT_API_PARAMS_REQ = 'REMEMBER_PROJECT_API_PARAMS_REQ';
export const REMEMBER_PROJECT_API_PARAMS_OK = 'REMEMBER_PROJECT_API_PARAMS_OK';

export const REMEMBER_PROJECT_API_RESULT_REQ = 'REMEMBER_PROJECT_API_RESULT_REQ';
export const REMEMBER_PROJECT_API_RESULT_OK = 'REMEMBER_PROJECT_API_RESULT_OK';

export const GET_PROJECT_API_HISTORY_REQ = 'GET_PROJECT_API_HISTORY_REQ';
export const GET_PROJECT_API_HISTORY_OK = 'GET_PROJECT_API_HISTORY_OK';

export const STORE_PROJECT_API_HISTORY_REQ = 'STORE_PROJECT_API_HISTORY_REQ';
export const STORE_PROJECT_API_HISTORY_OK = 'STORE_PROJECT_API_HISTORY_OK';
